import { render, staticRenderFns } from "./ResourceArnTableCell.vue?vue&type=template&id=23d90098&scoped=true"
import script from "./ResourceArnTableCell.vue?vue&type=script&lang=js"
export * from "./ResourceArnTableCell.vue?vue&type=script&lang=js"
import style0 from "./ResourceArnTableCell.vue?vue&type=style&index=0&id=23d90098&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d90098",
  null
  
)

export default component.exports